import { NavSection } from '@components/v2/layout/AppTemplate/appTemplate.types';
import { ElementType } from 'react';
import { CustomMenuItemProps } from '../../components/Menu/CustomMenu';

interface ToNavSectionsOptions {
  iconMap?: Record<string, ElementType>;
  getTestId?: (item: CustomMenuItemProps['items'][number]) => string;
}

export const toNavSections = (
  groups: CustomMenuItemProps[],
  { iconMap, getTestId }: ToNavSectionsOptions = {},
): NavSection[] =>
  groups
    .filter((group) => group.items.length > 0)
    .map((group) => ({
      title: group.label,
      items: group.items.map((item) => ({
        label: item.label,
        icon: iconMap?.[item.name],
        pathname: item.pathname,
        testId: getTestId?.(item),
      })),
    }));
